import { containerTwo, inputStyleTwo, errorText, btnOne } from "../utils/style";
import logo from '../assets/icons/ev-logo.png'
import { url } from "../utils/config";


function EmailScreen({ email, setEmail, error, getOtp, uiConfig}) {

    return(
        <div className={containerTwo}>
            <div className="flex justify-center items-center basis-2/3">
                <img src={uiConfig?.logos?.landingLogo ? url + '/images/' + uiConfig.logos.landingLogo : logo} height={200} width={200} />
            </div>
            <div className="basis-1/3">
                <div className='py-1 font-bold text-[20px]'>Get Started with Roll & Charge</div>
                <div className={'text-[14px]'}>Enter your email address for the verification code.</div>
                <div className="py-2">
                    <input 
                        className={inputStyleTwo}
                        placeholder={`Please enter your email address`} 
                        value={email} 
                        type="email"
                        onChange={e => setEmail(e.target.value)}  
                    />
                    {
                        error && <div className={errorText}>{error}</div>
                    }
                </div>
                <div className="py-2">
                    <button className={btnOne} onClick={() => getOtp()}><span className="">Send verification code</span></button>
                </div>
                <div className="text-right text-sm text-gray-300 p-2">Version 1.0</div>
            </div>
        </div>
    )
}

export default EmailScreen;